
import Vue from 'vue';
import { Component, Prop, Ref, Watch } from 'vue-property-decorator';
import { MglMarker, MglMap } from 'vue-mapbox';
import MapboxConfig from '@/config/MapboxConfig';
import { Location } from '@/generated-clients/myTrips';
import IconCarMarker from '@components/icons/icon-car-marker.svg'
import IconMapPoint from '@components/icons/icon-map-point.svg';
import IconWheelMarker from '@components/icons/icon-wheel-marker.svg';

@Component({
  name: 'PositionMap',
  components: {
    MglMap,
    MglMarker,
    IconCarMarker,
    IconMapPoint,
    IconWheelMarker
  }
})
export default class PositionMap extends Vue {
  @Prop()
  private position: Location;

  @Prop({ default: true })
  private interactive: boolean

  @Prop({ required: false })
  private showSimpleMarker: boolean;

  @Prop({ required: false, default: "car-marker" })
  private markerIcon: "map-point" | "car-marker" | "wheel-marker"; // names must exactly correspond to their respective icon svg files

  private delayLoad = true;

  private mapCenter: [number, number] | undefined = undefined;

  static readonly DELAY = 50;

  static readonly DEFAULT_COORDINATES: [number, number]  = [13.229, 47.735];

  $refs!: {
    mglMap: MglMap
  }

  // When component is created with certain props which change so fast the map
  // was not yet loaded, then the zoom level and position of the map does not update.
  // We add a very few ms delay in order to compensate for this very rapid changes
  // on the initial props
  created() {
    // mapCenter is initially set, but removed later,
    // so that the panning to a location on the map is smoothly animated
    this.mapCenter = this.coordinates || undefined;
    setTimeout(() => this.delayLoad = false, PositionMap.DELAY);
  }

  get mapboxAccessToken() {
    return MapboxConfig.accessToken;
  }

  get coordinates(): [number, number]  {
    return this.position ? [this.position.longitude, this.position.latitude] : PositionMap.DEFAULT_COORDINATES;
  }

  @Watch("coordinates")
  private panToCoordinates() {
    if (this.mapCenter) {
      this.mapCenter = undefined;
      // delay added so that the panTo animation runs smoothly
      setTimeout(() => this.$refs.mglMap?.actions?.panTo(this.coordinates), PositionMap.DELAY + 50)
    } else {
      this.$refs.mglMap?.actions?.panTo(this.coordinates)
    }
  }

  get zoom() {
    return this.position ? 14 : 5;
  }
}
